import * as React from 'react'

/* Assets */
import Star from 'images/white-star.svg'
import HeaderShadow from 'images/header-shadow-desktop-white.svg'
import { ReactComponent as IconInformation } from 'images/icons/icon-information.svg'
import ExpandableImageContainer from './ExpandableImageContainer'

/*
 * @dev: Common header for QR claim system
 * */
const ClaimHeader: React.FC<{
  title: string
  image: string
  originalImage: string
  claimed?: boolean
  showEventInfo?: boolean
}> = ({ title, image, originalImage, claimed = true, showEventInfo }) => {
  return (
    <div className={'claim-header'}>
      {!claimed && (
        <a className={'help-link'} href="https://poap.zendesk.com/hc/en-us/articles/9494654007437-What-Is-POAP-">
          <IconInformation width={15} height={15} /> What is POAP?
        </a>
      )}
      {(showEventInfo || showEventInfo === undefined) && image && (
        <>
          <div className={'title'}>{title}</div>
          <ExpandableImageContainer className="logo-event" src={originalImage} alt="Event">
            <div className="image-wrapper">{image && <img src={image} alt="Event" />}</div>
            {claimed && (
              <div className={'claimed-badge'}>
                <img src={Star} alt={'Badge claimed'} />
              </div>
            )}
          </ExpandableImageContainer>
        </>
      )}
      <div className={'wave-holder' + (showEventInfo !== undefined && !showEventInfo ? ' empty' : '')}>
        <img src={HeaderShadow} alt={''} />
      </div>
    </div>
  )
}

export default ClaimHeader
